'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsBot = undefined;

var _reselect = require('reselect');

var _getBotResponder = require('conversations-schema/operators/widget-data/getBotResponder');

var _getWidgetData = require('./getWidgetData');

var getIsBot = exports.getIsBot = (0, _reselect.createSelector)(_getWidgetData.getWidgetData, function (widgetData) {
  return Boolean((0, _getBotResponder.getBotResponder)(widgetData));
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getIsBot.js
// module id = 320
// module chunks = 2 3